
import { Component, OnInit } from '@angular/core';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { SMSService } from 'src/app/services/SMS/sms.service';
import { LookupService } from 'src/app/services/Common/lookup.service';
import * as moment from 'moment';

@Component({
  selector: 'app-fee-due-alert',
  templateUrl: './fee-due-alert.component.html',
  styleUrls: ['./fee-due-alert.component.css']
})

export class FeeDueAlertComponent implements OnInit {


  Submitted: boolean = false;
  GroupContactDueList: any;
  GroupDropDownList: any;
  FeeCollectionList: any;
  ClassList: any;
  SectionList: any;
  StudentList: any;
  TemplateList: any;
  Group: any;
  Count: number = 0;
  PersonList: any;
  DueList: any;
  ContactSubmitted: boolean = false;
  GroupContactList: any;
  currentPage: number = 1;
  pageSize: number = 10;
  numberOfCharacters: any;
  SMSCount: any;

  constructor(private SmsService: SMSService, private LookupService: LookupService, public globalHelper: GlobalHelper,
    private spinnerService: Ng4LoadingSpinnerService) { }

  FeeDueAlertModel = {
    ClassID: 0,
    SectionID: 0,
    StudentID: 0,
    TemplateID: 0,
    PersonTypeID: 0,
    CurrentIndex: 0,
    PageSize: 0,
    Message: '',
    SendTypeID:1,
    MessageType: "TEXT",
    DLTTemplateID:'',
    FromDate: moment(new Date()).format('DD-MMM-YYYY'),
  }



  ChangeDue(item) {
    item.Message = this.FeeDueAlertModel.Message.replace("$$StudentName$$", item.Name).replace("$$DueAmount$$", (parseFloat(item.DueAmount)).toString()).replace("$$Currency$$", this.globalHelper.GetLoginToken().CurrencyCode);
  }

  ChangeDueGroup(item) {
    item.Message = this.FeeDueAlertModel.Message.replace("$$StudentName$$", item.Name).replace("$$DueAmount$$", (parseFloat(item.DueAmount) + parseFloat(item.TDueAmount)).toString()).replace("$$Currency$$", this.globalHelper.GetLoginToken().CurrencyCode);
  }

  // this.DueList = [];


  GetFeeDueAlert() {
    this.spinnerService.show();
    
    this.DueList = [];
    this.PersonList = [];
    this.FeeDueAlertModel.FromDate = this.FeeDueAlertModel.FromDate != null && this.FeeDueAlertModel.FromDate != '' ? moment(this.FeeDueAlertModel.FromDate).format('DD-MMM-YYYY') : '';
    this.SmsService.SMS_GetFeeDueAlert(JSON.stringify(this.FeeDueAlertModel)).subscribe((data: any) => {
      this.FeeCollectionList = data.FeeCollectionList;
      
      if (this.FeeCollectionList != null) {
        for (var i = 0; i < this.FeeCollectionList.length; i++) {
          var item = {
            Mobile: this.FeeCollectionList[i].Mobile,
            PersonID: this.FeeCollectionList[i].StudentID,
            DueAmount: (parseFloat(this.FeeCollectionList[i].TotalPayableAmountOnDate) + parseFloat(this.FeeCollectionList[i].OpenningBalance) - parseFloat(this.FeeCollectionList[i].TotalPaidAmountOnDate)),
            StudentID: this.FeeCollectionList[i].StudentID,
            ClassName: this.FeeCollectionList[i].ClassName,
            SectionName: this.FeeCollectionList[i].SectionName,
            StudentNo: this.FeeCollectionList[i].StudentNo,
            GRNo: this.FeeCollectionList[i].GRNo,
            Name: this.FeeCollectionList[i].Name,
            OpenningBalance: this.FeeCollectionList[i].OpenningBalance,
            DLTTemplateID:this.FeeDueAlertModel.DLTTemplateID,
            Message: this.FeeDueAlertModel.Message.replace("$$StudentName$$", this.FeeCollectionList[i].Name).replace("$$DueAmount$$", this.globalHelper.Decimal(parseFloat(this.FeeCollectionList[i].TotalPayableAmountOnDate) + parseFloat(this.FeeCollectionList[i].OpenningBalance) - parseFloat(this.FeeCollectionList[i].TotalPaidAmountOnDate))).replace("$$Currency$$", this.globalHelper.GetLoginToken().CurrencyCode),
         }
          this.DueList.push(item);
        }
      }
      this.spinnerService.hide();
      // this.globalHelper.CheckActionStatus(data);
    });

  };



  SendFeeDueAlert() {

    this.PersonList = [];

    if (this.FeeDueAlertModel.PersonTypeID == 1) {

      this.spinnerService.show();
      for (var i = 0; i < this.DueList.length; i++) {
        if (this.DueList[i].IsSelect == true) {
          var item = {
            PersonID: this.DueList[i].PersonID,
            Mobile: this.DueList[i].Mobile,
            Message: this.DueList[i].Message,
            DLTTemplateID: this.DueList[i].DLTTemplateID
          }
          this.PersonList.push(item);
        }
      }
      this.SmsService.SendFeeDueAlert(JSON.stringify(this.PersonList), this.FeeDueAlertModel.PersonTypeID, this.FeeDueAlertModel.MessageType,this.FeeDueAlertModel.SendTypeID).subscribe((data: any) => {
        if (data.webResponse.Status) {

          this.spinnerService.hide();
          this.DueList.splice(0);
        }
        this.globalHelper.CheckActionStatus(data);
      });
    }

    else if (this.FeeDueAlertModel.PersonTypeID == 3) {

      this.spinnerService.show();
      for (var i = 0; i < this.GroupContactDueList.length; i++) {
        if (this.GroupContactDueList[i].IsSelect == true) {
          var item = {

            PersonID: this.GroupContactDueList[i].ContactID,
            Mobile: this.GroupContactDueList[i].Mobile,
            Message: this.GroupContactDueList[i].Message,
            DLTTemplateID: this.GroupContactDueList[i].DLTTemplateID
          }
          this.PersonList.push(item);
        }

      }
      this.SmsService.SendFeeDueAlert(JSON.stringify(this.PersonList), this.FeeDueAlertModel.PersonTypeID, this.FeeDueAlertModel.MessageType,this.FeeDueAlertModel.SendTypeID,).subscribe((data: any) => {
        if (data.webResponse.Status) {

          this.spinnerService.hide();
          this.GroupContactDueList.splice(0);
        }
        this.globalHelper.CheckActionStatus(data);
      });
    }


  }




  // Group

  SearchModel = {
    GroupID: 0,
    Name: '',
    Mobile: '',
    CurrentIndex: 0,
    PageSize: 20
  }

  GetGroupContact() {
    this.spinnerService.show();
    this.GroupContactDueList = [];

    this.SearchModel.CurrentIndex = this.currentPage;
    this.SearchModel.PageSize = 0;
    this.SmsService.GetGroupContact(JSON.stringify(this.SearchModel)).subscribe((data: any) => {

      this.GroupContactList = data.GroupContactList;
      for (var i = 0; i < this.GroupContactList.length; i++) {

        var item = {
          Mobile: this.GroupContactList[i].Mobile,
          ContactID: this.GroupContactList[i].ContactID,
          DueAmount: 0,
          TDueAmount: 0,
          Name: this.GroupContactList[i].Name,
          DOB: this.GroupContactList[i].DOB,
          GroupName: this.GroupContactList[i].GroupName,
          Message: this.FeeDueAlertModel.Message.replace("$$StudentName$$", (this.GroupContactList[i].Name)).replace("$$DueAmount$$", '0').replace("$$Currency$$", this.globalHelper.GetLoginToken().CurrencyCode),
          numberOfCharacters: this.FeeDueAlertModel.Message.replace("$$StudentName$$", this.GroupContactList[i].Name).replace("$$DueAmount$$", '0').length,
          SMSCount: Math.ceil((this.FeeDueAlertModel.Message.replace("$$StudentName$$", this.GroupContactList[i].Name).replace("$$DueAmount$$", '0').length) / 160)
        }
        this.GroupContactDueList.push(item);



      }
      this.spinnerService.hide();
    });
  };


  ngOnInit() {

    if (this.globalHelper.GetLoginToken().IsSMSPackage) {
      this.FeeDueAlertModel.PersonTypeID = 3;
      this.GetAllGroup();
    }
    else {
      this.FeeDueAlertModel.PersonTypeID = 1;
      this.GetClass();
    }
    this.GetAlertTypeMessage();
  }

  GetAllGroup() {
    this.LookupService.GetLookupsList('SMSGroup', '').subscribe((data: any) => {
      this.GroupDropDownList = data.LookupItems;
    });

  }

  GetClass() {
    this.LookupService.GetLookupsList('Class', '').subscribe((data: any) => {
      this.ClassList = data.LookupItems;
    });
  };

  GetSection() {
    this.FeeDueAlertModel.SectionID = 0;
    this.FeeDueAlertModel.StudentID = 0;
    this.DueList = [];
    var itemBo = {
      'ItemId': this.FeeDueAlertModel.ClassID,

    };
    this.spinnerService.show();
    this.LookupService.GetLookupsList('SectionName', JSON.stringify(itemBo)).subscribe((data: any) => {
      this.SectionList = data.LookupItems;
      this.spinnerService.hide();
    });

  };

  GetStudent() {
    this.DueList = [];
    var itemBo = {
      'ItemId': this.FeeDueAlertModel.ClassID,
      'ItemId2': this.FeeDueAlertModel.SectionID
    };
    this.spinnerService.show();
    this.LookupService.GetLookupsList('Student', JSON.stringify(itemBo)).subscribe((data: any) => {
      this.StudentList = data.LookupItems;
      this.spinnerService.hide();
    });
  };

  GetAlertTypeMessage() {
    var itrmbo = {
      ItemId: 4
    }
    this.LookupService.GetLookupsList('AlertTypeMessage', JSON.stringify(itrmbo)).subscribe((data: any) => {
     
      this.TemplateList = data.LookupItems;
      this.FeeDueAlertModel.Message = this.TemplateList[1].ItemName;
      this.FeeDueAlertModel.MessageType = this.TemplateList[1].ItemCode1;
      this.FeeDueAlertModel.DLTTemplateID = this.TemplateList[1].DLTTemplateID;

     

      this.numberOfCharacters = this.FeeDueAlertModel.Message.length;

      this.SMSCount = Math.ceil(this.numberOfCharacters / 160);

    });
  };



  SelectModel = {
    Active: false,
  };

  SelectAll() {
    if (this.FeeDueAlertModel.PersonTypeID == 1) {

      if (this.SelectModel.Active) {
        for (var i = 0; i < this.DueList.length; i++) {
          this.DueList[i].IsSelect = true;
        }
      }
      if (this.SelectModel.Active == false) {
        for (var i = 0; i < this.DueList.length; i++) {
          this.DueList[i].IsSelect = false;
        }
      }

    }

    else if (this.FeeDueAlertModel.PersonTypeID == 3) {

      if (this.SelectModel.Active) {
        for (var i = 0; i < this.GroupContactDueList.length; i++) {
          this.GroupContactDueList[i].IsSelect = true;
        }
      }
      if (this.SelectModel.Active == false) {
        for (var i = 0; i < this.GroupContactDueList.length; i++) {
          this.GroupContactDueList[i].IsSelect = false;
        }
      }
    }
  }

  ChangeSelect(item) {
    this.Count = 0;
    if (this.FeeDueAlertModel.PersonTypeID == 1) {
      for (var i = 0; i < this.DueList.length; i++) {
        if (this.DueList[i].IsSelect) {
          this.Count = this.Count + 1;

        }
      }
      if (this.Count == this.DueList.length) {
        this.SelectModel.Active = true;

      }
      else {
        this.SelectModel.Active = false;
      }

    }

    else if (this.FeeDueAlertModel.PersonTypeID == 3) {
      for (var i = 0; i < this.GroupContactDueList.length; i++) {
        if (this.GroupContactDueList[i].IsSelect) {
          this.Count = this.Count + 1;

        }
      }
      if (this.Count == this.GroupContactDueList.length) {
        this.SelectModel.Active = true;

      }
      else {
        this.SelectModel.Active = false;
      }

    }
  }

  // Print


  // PrintFeeReminderAll() {

  //   var Template = this.globalHelper.GetLoginToken().FeeReminderTemplate;
  //   var Template = "feeduealertprint";
  //   var objStudent = '';
  //   var objClassID = this.FeeDueAlertModel.ClassID;
  //   var objSectionID = this.FeeDueAlertModel.SectionID;
  //   for (var i = 0; i < this.DueList.length; i++) {
  //     if (this.DueList[i].IsSelect) {
  //       objStudent = objStudent == '' ? this.DueList[i].StudentID : objStudent + ',' + this.DueList[i].StudentID;

  //     }
  //   }

  //   var url = Template + "?StudentID=" + objStudent + "&ClassID=" + objClassID + "&SectionID=" + objSectionID + "&FromDate=" + this.FeeDueAlertModel.FromDate;
  //   this.globalHelper.OpenPopUpWindow(url, "yes", "950", "1000");
  // };

  // PrintFeeReminder(item) {
  //   var Template = this.globalHelper.GetLoginToken().FeeReminderTemplate;
  //   var Template = "feeduealertprint";
  //   var objStudent = item.StudentID;
  //   var objClassID = this.FeeDueAlertModel.ClassID;
  //   var objSectionID = this.FeeDueAlertModel.SectionID;

  //   var url = Template + "?StudentID=" + objStudent + "&ClassID=" + objClassID + "&SectionID=" + objSectionID + "&FromDate=" + this.FeeDueAlertModel.FromDate;
  //   this.globalHelper.OpenPopUpWindow(url, "yes", "950", "1000");

  // }



}